var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 72 72",
    id: "emoji",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8257E6",
    d: "M28.3493,64.0547a14.1852,14.1852,0,0,1-9.08-25.083,1,1,0,0,1,1.6318.8994c-.7138,5.3779,5.1221,9.1143,5.1817,9.1514a1.0006,1.0006,0,0,1-.5313,1.8476H20.9782a7.438,7.438,0,0,0,14.8086-1V23a8.91,8.91,0,1,1,6.747.2344V49.87A14.2007,14.2007,0,0,1,28.3493,64.0547ZM39.445,12.7188a2.1643,2.1643,0,1,0,2.164,2.164A2.1664,2.1664,0,0,0,39.445,12.7188Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8257E6000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.5511,49.87s-6.4505-4.0285-5.64-10.1295L19.91,39.74A13.1848,13.1848,0,1,0,41.5335,49.87V22.5059a7.9115,7.9115,0,1,0-4.7465-.18V49.87a8.4382,8.4382,0,1,1-16.8763,0h.8339M41.2972,17.4489a3.1645,3.1645,0,1,1,1.3123-2.566"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHookIcon);
export default __webpack_public_path__ + "static/media/hookIcon.42cd0782b55c17ef3bfa261ed344ae94.svg";
export { ForwardRef as ReactComponent };